import countly from "../../analytics/countly";

import { EVENT_NAMES } from "../../analytics/events";
import { unsetUserAction } from "../../redux/actions/Auth/userLoginAction";
import { noAuthAction } from "../../redux/actions/Auth/Thunk/checkAuthThunkAction";
import { removeCookiesThunkAction } from "../../redux/actions/Auth/Thunk/removeCookies.thunk.action";

import { unsetPersonalData } from "../../redux/actions/User/LogOut/userLogOutAction";

import { unsetMealCardBalanceAction } from "../../redux/actions/User/profile/Widgets/getFoodCardBalance.action";
import { getLeaderRequestsAction } from "../../redux/actions/Requests/LeaderRequests/getLeaderRequests.action";
import { getUserHrDocsAction } from "../../redux/actions/Requests/Hr-documents/getUserHrDocs.action";
import { getAllUserRequestsAction } from "../../redux/actions/Requests/GetUserRequests/getAllUserRequests.action";
import { getAllUserReferencesAction } from "../../redux/actions/Requests/References/getAllUserReferences.action";
import { getAllDocumentsAction } from "../../redux/actions/Documents/AllDocuments/getAllDocuments.action";
import { setCurrentHrDocsAction } from "../../redux/actions/Requests/Hr-documents/setCurrenrRequest.action";
import { unsetCurrentDocumentAction } from "../../redux/actions/Requests/CurrentRequest/setCurrentDocument.action";
import { clearClaims } from "../../redux/actions/User/User Claims/claimsActions";

import { useCallback } from "react";
import { useDispatch } from "react-redux";


export function useLogout(navigate) {
    const dispatch = useDispatch();
    const logout = useCallback(() => {
        countly.event(EVENT_NAMES.LOGOUT, { pid: localStorage.getItem("pid") });
        countly.clearUser();
        localStorage.clear();
        dispatch(unsetUserAction());
        dispatch(noAuthAction());
        dispatch(removeCookiesThunkAction());
        dispatch(unsetPersonalData());
        dispatch(getLeaderRequestsAction(null));
        dispatch(getUserHrDocsAction(null));
        dispatch(setCurrentHrDocsAction(null));
        dispatch(getAllUserRequestsAction(null));
        dispatch(getAllUserReferencesAction(null));
        dispatch(getAllDocumentsAction(null));
        dispatch(unsetMealCardBalanceAction());
        dispatch(unsetCurrentDocumentAction());
        navigate("/start");
    }, [navigate]);
    return logout;
}

